var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaleGender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_5_",
    "data-name": "user (5)",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_172",
    "data-name": "Ellipse 172",
    cx: 47.5,
    cy: 47.5,
    rx: 47.5,
    ry: 47.5,
    transform: "translate(0 -0.001)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2947",
    "data-name": "Path 2947",
    d: "M134.2,127.639a17.7,17.7,0,0,0-7.343-3.391l-13.07-2.622a2.948,2.948,0,0,1-2.36-2.92v-3a35.812,35.812,0,0,0,2.461-4.386,24.081,24.081,0,0,1,2.1-3.677c2.646-2.658,5.2-5.644,6-9.494.739-3.612.012-5.507-.84-7.033,0-3.808-.119-8.576-1.019-12.045-.107-4.7-.96-7.336-3.105-9.649-1.514-1.639-3.743-2.02-5.537-2.324a9.676,9.676,0,0,1-2.032-.477A21.032,21.032,0,0,0,99.384,64c-7.849.322-17.5,5.316-20.728,14.22-1,2.712-.9,7.164-.817,10.74l-.077,2.151a9.546,9.546,0,0,0-.781,7.033c.787,3.856,3.343,6.848,6.037,9.542a26.159,26.159,0,0,1,2.092,3.659,37.041,37.041,0,0,0,2.479,4.369v3a2.962,2.962,0,0,1-2.372,2.92l-13.082,2.622a17.736,17.736,0,0,0-7.319,3.385,2.987,2.987,0,0,0-.352,4.339,47.448,47.448,0,0,0,70.088,0,2.986,2.986,0,0,0-.352-4.339Z",
    transform: "translate(-51.83 -52.438)",
    fill: "#2196f3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleGender);
export default __webpack_public_path__ + "static/media/male-gender.e5602416eafa3258dc19d29d993bf216.svg";
export { ForwardRef as ReactComponent };